import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { createRequestOption, IReconcileStatus, IReconcileTicketOverview, ITicketStatus, IBrand } from '@appshared';

@Injectable({
  providedIn: 'root',
})
export class DataListApiService {
  protected urlTickets = '/sale-data-svc/api/tickets/';
  protected urlFilterOptions = '/sale-data-svc/api/tickets/filter-options/';
  protected urlStoresOptions = '/sale-data-svc/api/stores/';
  ticketStatuses: Array<ITicketStatus> = [];
  reconcileStatuses: Array<IReconcileStatus> = [];
  brands: Array<IBrand> = [];

  constructor(public httpClient: HttpClient) {}

  query(req?: any, type: string = ''): Observable<any> {
    const options = createRequestOption(req);
    return this.httpClient.get<IReconcileTicketOverview[]>(`${this.urlTickets}${type}`, { params: options });
  }

  getFilterOptions(): Observable<any> {
    return this.httpClient.get<any>(`${this.urlFilterOptions}`);
  }

  getStoresOptions(): Observable<any> {
    return this.httpClient.get<any>(`${this.urlStoresOptions}`);
  }

  copyData(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }
}
